<!--
    描述：项目管理-- 聚易厅项目-- 查看详情页
    时间：2022-05-07
    Created by 何伟
-->
<template>
  <div class="juyi-project-msg-main">
    <div class="juyihead">
      <el-tabs v-model="auditType" @tab-click="tabChange(auditType)">
        <el-tab-pane label="项目基本信息" name="1">
          <pro-baseinfo :rowData="rowData"> </pro-baseinfo>
        </el-tab-pane>
        <el-tab-pane label="投标人/投标保证金" name="2">
          <bid-bond ref="bidBond" :rowData="rowData"></bid-bond>
        </el-tab-pane>
        <el-tab-pane label="项目合同" name="3">
          <projectContract
            ref="projectContract"
            :rowData="rowData"
          ></projectContract>
        </el-tab-pane>
        <el-tab-pane label="服务费托管" name="9">
          <fee-hosting ref="feeHosting" :rowData="rowData"></fee-hosting>
        </el-tab-pane>
        <el-tab-pane label="项目进度更新" name="4">
          <pro-progress-update
            ref="proProgressUpdate"
            :rowData="rowData"
          ></pro-progress-update>
        </el-tab-pane>
        <el-tab-pane label="项目成果验收" name="5">
          <pro-result-acceptance
            ref="proResultAcceptance"
            :rowData="rowData"
          ></pro-result-acceptance>
        </el-tab-pane>
        <el-tab-pane label="项目佣金发放" name="6">
          <pro-commission-issue
            ref="proCommissionIssue"
            :rowData="rowData"
          ></pro-commission-issue>
        </el-tab-pane>
        <el-tab-pane label="项目发票" name="7">
          <pro-bill ref="proBill" :rowData="rowData"></pro-bill>
        </el-tab-pane>
        <el-tab-pane label="雇主方评价" name="8">
          <employer-evaluation
            ref="employerEvaluation"
            :rowData="rowData"
          ></employer-evaluation>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import proBaseinfo from "./pro-baseinfo";
import bidBond from "./bidBond";
import projectContract from "./projectContract";
import feeHosting from "./fee-hosting";
import proProgressUpdate from "./pro-progress-update";
import proResultAcceptance from "./pro-result-acceptance";
import proCommissionIssue from "./pro-commission-issue";
import proBill from "./pro-bill";
import employerEvaluation from "./employer-evaluation";
export default {
  components: {
    proBaseinfo,
    bidBond,
    projectContract,
    feeHosting,
    proProgressUpdate,
    proResultAcceptance,
    proCommissionIssue,
    proBill,
    employerEvaluation
  },
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    audit: {
      type: String,
      default: ""
    }
  },
  filters: {
    dateFilter(time) {
      return bmTooljs.dateformat(new Date(time), "yyyy-MM-dd");
    }
  },
  data() {
    return {
      // progresslist: [
      // 	{
      // 		desc: '发布需求',
      // 		arise: 1,
      // 		createDate: '2022-04-02 18:11:02'
      // 	},
      // 	{
      // 		desc: '投标报名',
      // 		arise: 0,
      // 		createDate: '2022-04-02 18:11:02'
      // 	},
      // 	{
      // 		desc: '确定中标人，托管费用',
      // 		arise: 0,
      // 		createDate: '2022-04-02 18:11:02'
      // 	}
      // 	,
      // 	{
      // 		desc: '签订合同',
      // 		arise: 0,
      // 		createDate: '2022-04-02 18:11:02'
      // 	}
      // 	,
      // 	{
      // 		desc: '工作中',
      // 		arise: 0,
      // 		createDate: '2022-04-02 18:11:02'
      // 	}
      // 	,
      // 	{
      // 		desc: '验收成果，支付佣金',
      // 		arise: 0,
      // 		createDate: '2022-04-02 18:11:02'
      // 	}
      // 	,
      // 	{
      // 		desc: '开票',
      // 		arise: 0,
      // 		createDate: '2022-04-02 18:11:02'
      // 	}
      // 	,
      // 	{
      // 		desc: '雇主评价',
      // 		arise: 0,
      // 		createDate: '2022-04-02 18:11:02'
      // 	}

      // ], // 进度条数据

      // juyiProjectMsg: {
      // 	id: '',
      // 	baseId: '',
      // 	businessId: '',
      // 	sname: "",
      // 	projectTypeName: "",
      // 	subTypeName: "",
      // 	description: "",
      // 	pubType: "",
      // 	allowBids: "",
      // 	bidMode: '',
      // 	registrationDeadline: "",
      // 	projectProvinceName: "",
      // 	projectCityName: "",
      // 	projectAreaName: "",
      // 	detailAddress: "",
      // 	employerOffer: "",
      // 	exDelDate: "",
      // 	stageFlag: '',
      // 	depositFlag: '',
      // 	structureArea: "",
      // 	linkPhone: "",
      // 	createDate: ''
      // },
      // checkData: [],//操作记录
      auditType: "1" //tab项当前值
    };
  },
  created() {
    if (!this.rowData.id) {
      this.$router.push({
        name: "juyi-project-list"
      });
      return;
    }
    //数据加载
    // this.getProjectMsgForJuyi()
    // if (this.audit === 'view') {
    // 	//操作记录
    // 	this.getProjectAuditLog()
    // }
  },
  methods: {
    // tab切换
    tabChange(val) {
      this.currentPage = 1;
      this.pageSize = 10;
      if (val == 4) {
        this.auditState = "";
      } else {
        this.auditState = val;
      }

      switch (val) {
        case "2":
          this.$refs.bidBond.getBidderList();
          break;
        case "3":
          this.$refs.projectContract.getContractPageList();
          break;
        case "9":
          this.$refs.feeHosting.getTrusteeFeeGetProjectInfo();
          break;
        case "4":
          this.$refs.proProgressUpdate.getScheduleUpdatePageList();
          break;
        case "5":
          this.$refs.proResultAcceptance.getAcceptPageList();
          break;
        case "6":
          this.$refs.proCommissionIssue.getBusSettlementPageList();
          break;
        case "7":
          this.$refs.proBill.queryApplicationInvoiceList();
          break;
        case "8":
          this.$refs.employerEvaluation.getEvaluatePageList();
          break;
      }
      // this.getTabNum()
      // this.getData()
    }
    // // 审核
    // auditSubmit() {
    // 	let params = {
    // 		id: this.juyiProjectMsg.baseId
    // 	}

    // 	this.$emit('openDia', params)
    // },
    // //获取聚易厅项目
    // getProjectMsgForJuyi() {
    // 	getProjectMsgByIdForJuyi({
    // 		id: this.rowData.id
    // 	}).then(res => {
    // 		if (res.operationCode == '1') {
    // 			this.juyiProjectMsg = res.data.juyiProject
    // 			this.juyiProjectMsg.sname = res.data.msgProject.sname
    // 			this.juyiProjectMsg.createDate = res.data.msgProject.createDate
    // 		}
    // 	})
    // },
    // //查询审核记录
    // getProjectAuditLog() {
    // 	getProjectAuditLog({
    // 		baseId: this.rowData.id
    // 	}).then(res => {
    // 		if (res.operationCode == '1') {
    // 			this.checkData = res.data
    // 		}
    // 	})
    // }
  }
  // computed: {
  // 	...mapState('dict', {
  // 		projectDict: (state) => state.projectDict,
  // 	}),
  // },
};
</script>
<style scoped lang="less">
.juyi-project-msg-main {
  // height: 100%;
  .juyihead {
    padding: 15px 15px;
    background: #fff;
    /deep/.el-tabs__item {
      width: 140px;
    }
  }
}
</style>
